import React, { useState, useEffect, Fragment } from "react";
import services from "../services";
import { CardPrintFilteringSchema } from "../CardSchema";
import { EmployeeCardPrintListing } from "../Pages/listing";
import { PageHeader } from "../../../../Common";
import { validateProperty, validate } from "../../../Common";
import Joi from "@hapi/joi";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import authService from "../../../Common/services";
import tokenService from "../../../../Common/tokenDecoder";
import { trackPromise } from "react-promise-tracker";
import { LoadingSpinerComponent } from "../../../../Common/loader";

const screenCode = "EMPLOYEECARDPRINT";

export function EmployeeCardPrintFiltering(props) {
  const [title, setTitle] = useState("Employee Card Print");
  const [operationEntities, setOperationEntities] = useState([]);
  const [groups, setGroups] = useState();
  const [collectionPoint, setCollectionPoint] = useState([]);
  const [cardPrintData, setCardprintData] = useState([]);
  const [cardPrintFilter, setCardPrintFilter] = useState({
    cardID: "",
    cardNumber: "",
    collectionPointID: "0",
    firstName: "",
    groupID: "0",
    nameToBePrinted: "",
    operationEntityID: "0",
    registrationNumber: "",
    employeeTypeID: "0",
    isRsm: false
  });
  const [errors, setErrors] = useState({});
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isOperationEntityFilterEnabled: false,
  });
  const schema = Joi.object(CardPrintFilteringSchema).options({
    allowUnknown: true,
  });
  const [employeeTypes, setEmployeeTypes] = useState([]);

  useEffect(() => {
    getPermissions();
  }, []);

  useEffect(() => {
    trackPromise(getOperationEntityForDropdown());
  }, [cardPrintFilter.groupID]);

  useEffect(() => {
    trackPromise(getCollectionPointForDropDown());
  }, [cardPrintFilter.operationEntityID]);

  async function getGroupsForDropdown() {
    const result = await services.getAlGroupsForDropdown();
    setGroups(result);
  }

  async function getOperationEntityForDropdown() {
    const operationEntity = await services.getAllOperationEntitiesForDropDown(cardPrintFilter.groupID);
    setOperationEntities(operationEntity);
  }

  async function getCollectionPointForDropDown() {
    const collectionPoint = await services.GetCollectionPointsFilter(cardPrintFilter.operationEntityID);
    setCollectionPoint(collectionPoint);
  }

  async function getEmployeeTypesForDropdown() {
    const result = await services.getEmployeeTypesData();
    setEmployeeTypes(result);
}

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(
      (p) => p.permissionCode == "VIEWEMPLOYEECARDPRINTLISTING"
    );

    if (isAuthorized === undefined) {
      props.history.push("/unauthorized");
    }

    var isGroupFilterEnabled = permissions.find(
      (p) => p.permissionCode == "GROUPDROPDOWN"
    );
    var isOperationEntityFilterEnabled = permissions.find(
      (p) => p.permissionCode == "OPERATIONENTITYDROPDOWN"
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isOperationEntityFilterEnabled:
        isOperationEntityFilterEnabled !== undefined,
    });

    var token = tokenService.getUserDetailsFromToken();

    setCardPrintFilter({
      ...cardPrintFilter,
      groupID: token.groupID,
      operationEntityID: token.operationEntityID,
    });

    trackPromise(getGroupsForDropdown());

    trackPromise(getEmployeeTypesForDropdown());
  }

  function handleGroupChange(target) {
    validateInputs(target);

    setCardPrintFilter({
      ...cardPrintFilter,
      groupID: target.value,
      operationEntityID: "",
      collectionPointID: "0",
    });
  }

  function handleOperationEntityChange(target) {
    validateInputs(target);

    setCardPrintFilter({
      ...cardPrintFilter,
      operationEntityID: target.value,
      collectionPointID: "0",
      employeeTypeID: "0"
    });
  }

  function handleCollectionPointChange(target) {
    validateInputs(target);

    setCardPrintFilter({
      ...cardPrintFilter,
      collectionPointID: target.value,
      employeeTypeID: "0"
    });
  }

  function handleEmployeeTypeChange(target) {
    validateInputs(target);

    setCardPrintFilter({
      ...cardPrintFilter,
      employeeTypeID: target.value,
    });
  }

  function validateInputs(target) {
    const error = { ...errors };
    const errorMessage = validateProperty(target, CardPrintFilteringSchema);
    errorMessage
      ? (error[target.name] = errorMessage)
      : delete error[target.name];

    setErrors(error);
  }

  async function handleSearch(e) {
    e.preventDefault();
    const errorMessages = validate(schema, cardPrintFilter);
    errorMessages !== null ? setErrors(errorMessages) : setErrors({});
    if (errorMessages) return;

    const response = await services.getCardPrintDetails(
      cardPrintFilter.collectionPointID, cardPrintFilter.employeeTypeID, cardPrintFilter.isRsm
    );
    setCardprintData(response);
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  async function afterSuccessfulyChanged() {
    setCardprintData([]);
    const response = await services.getCardPrintDetails(cardPrintFilter.collectionPointID, cardPrintFilter.employeeTypeID,  cardPrintFilter.isRsm);
    setCardprintData(response);
  }

  function clearState() {
    setCardPrintFilter({
      ...cardPrintFilter,
      collectionPointID: "0",
      employeeTypeID: "0"
    });
    setCardprintData([]);
  }

  function onCancelClick() {
    clearState();
  }

  function handleChange(e) {
    setCardPrintFilter({
        ...cardPrintFilter,
        isRsm: e.target.checked
    })
  }

  return (
    <Fragment>
      <LoadingSpinerComponent />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <PageHeader title={title} />
              </div>
              <form onSubmit={(e) => handleSearch(e)} disabled={false}>
                <div className="form-group row">
                  <div className="col-md pb-1">
                    <InputLabel shrink id="groupID">
                      Group *
                    </InputLabel>
                    <Select
                      fullWidth
                      id="groupID"
                      name="groupID"
                      value={cardPrintFilter.groupID}
                      disabled={!permissionList.isGroupFilterEnabled}
                      onChange={(e) => handleGroupChange(e.target)}
                    >
                      <MenuItem value="0">--Select Group--</MenuItem>
                      {generateDropDownMenu(groups)}
                    </Select>
                    {errors["groupID"] && (
                      <FormHelperText error>{errors["groupID"]}</FormHelperText>
                    )}
                  </div>

                  <div className="col-md pb-1">
                    <InputLabel shrink id="operationEntityID">
                      Operation Entity *
                    </InputLabel>
                    <Select
                      fullWidth
                      id="operationEntityID"
                      name="operationEntityID"
                      value={cardPrintFilter.operationEntityID}
                      disabled={!permissionList.isOperationEntityFilterEnabled}
                      onChange={(e) => handleOperationEntityChange(e.target)}
                    >
                      <MenuItem value="0">--Select Operation Entity--</MenuItem>
                      {generateDropDownMenu(operationEntities)}
                    </Select>
                    {errors["operationEntityID"] && (
                      <FormHelperText error>
                        {errors["operationEntityID"]}
                      </FormHelperText>
                    )}
                  </div>

                  <div className="col-md">
                    <InputLabel shrink id="collectionPointID">
                      Collection Point *
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="collectionPointID"
                      id="collectionPointID"
                      name="collectionPointID"
                      value={cardPrintFilter.collectionPointID}
                      onChange={(e) => handleCollectionPointChange(e.target)}
                    >
                      <MenuItem value="0">--Select Collection Point--</MenuItem>
                      {generateDropDownMenu(collectionPoint)}
                    </Select>
                    {errors["collectionPointID"] && (
                      <FormHelperText error>
                        {errors["collectionPointID"]}
                      </FormHelperText>
                    )}
                  </div>
                </div>
                <div className="form-group row">
                <div className="col-md-4 pb-1">
                    <InputLabel shrink id="employeeTypeID">
                      Employee Type *
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="employeeTypeID"
                      id="employeeTypeID"
                      name="employeeTypeID"
                      value={cardPrintFilter.employeeTypeID}
                      onChange={(e) => handleEmployeeTypeChange(e.target)}
                    >
                      <MenuItem value="0">--Select Employee Type--</MenuItem>
                      {generateDropDownMenu(employeeTypes)}
                    </Select>
                    {errors["employeeTypeID"] && (
                      <FormHelperText error>
                        {errors["employeeTypeID"]}
                      </FormHelperText>
                    )}
                  </div>
                </div>
                <label>Is Rsm</label>
                <div className="form-group row">
                  <div className="col-md-4 pb-1">
                    <input
                      className="mr-2"
                      id="isRsm"
                      switch="none"
                      type="checkbox"
                      name="isRsm"
                      onChange={(e) => handleChange(e)}
                    />
                    <label
                      htmlFor="isRsm"
                      data-on-label="Yes"
                      data-off-label="No"
                    ></label>
                  </div>
                </div>

                <div className="card-footer">
                  <input
                    type="submit"
                    className="btn btn-primary"
                    value="Search"
                  />
                  <input
                    type="button"
                    className="btn btn-warning pull-right"
                    value="Clear"
                    onClick={onCancelClick}
                  />
                </div>

                <EmployeeCardPrintListing
                  cardPrintData={cardPrintData}
                  afterSuccessfulyChanged={afterSuccessfulyChanged}
                  cardPrintFilter={cardPrintFilter}
                />
              </form>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
